const componentName = 'cornerradiusinput';
export const dataHooks = {
    topLeft: `${componentName}-top-left-corner`,
    topRight: `${componentName}-top-right-corner`,
    bottomLeft: `${componentName}-bottom-left-corner`,
    bottomRight: `${componentName}-bottom-right-corner`,
    autoScaleButton: `${componentName}-linking-button`,
    liveRegion: `${componentName}-live-region`,
};
export const SIZE = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const POSITION = {
    topLeft: 'topLeft',
    topRight: 'topRight',
    bottomLeft: 'bottomLeft',
    bottomRight: 'bottomRight',
};
//# sourceMappingURL=CornerRadiusInput.constants.js.map